import { css } from 'styled-components';
import '../../themes/alert.js';
import '../../themes/button.js';
import '../../themes/checkbox.js';
import '../../themes/divider.js';
import '../../themes/dropdown.js';
import '../../themes/fieldset.js';
import { fontFamilyBook } from '../../themes/fonts.js';
import '../../themes/input.js';
import '../../themes/list.js';
import '../../themes/listbox.js';
import '../../themes/loader.js';
import '../../themes/option.js';
import '../../themes/popout.js';
import '../../themes/switch.js';
import '../../themes/themes.js';
import '../../themes/tooltip.js';

const baseListItemStyle = css`
  display: block;
  font-family: ${fontFamilyBook};
  font-size: 14px;
  line-height: 22px;
  margin: 0;
  overflow-wrap: anywhere;
`;

export { baseListItemStyle };
//# sourceMappingURL=listitem.js.map
